import { FC, useState } from 'react';

import { TEXTS } from 'application/pages/AdsPage/renderer/texts';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { DEFAULT_ERROR_MESSAGE } from '@shared/config';

import { useMediaAdCampaignRenameMutation } from '@shared/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import Input, { InputType } from '@zvuk-b2b/react-uikit/ui/Input';
import { toast } from '@shared/ui';

import { NOTIFICATIONS_TEXT, NAME_MAX_LENGTH_ERROR } from '../consts';
import styles from './index.module.scss';

const AdRenameModal: FC<ModalProps[ModalTypes.AD_CAMPAIGN_RENAME]> = ({ id, title, close }) => {
  const [renameMutation, { loading }] = useMediaAdCampaignRenameMutation();

  const [prevId, setPrevId] = useState(id);
  const [name, setName] = useState(title);

  if (prevId !== id) {
    setPrevId(id);
    setName(title);
  }

  const isRenameButtonDisabled = loading || name.length === 0 || name === title;

  const onRename = async () => {
    try {
      const result = await renameMutation({ variables: { adCompanyId: id, title: name } });

      if (!result.data?.adcampaignRename?.adCompany) throw new Error();

      toast.info(NOTIFICATIONS_TEXT.RENAME_SUCCESS);
      close();
    } catch (error: any) {
      if (JSON.stringify(error).includes(NAME_MAX_LENGTH_ERROR)) {
        toast.error(NOTIFICATIONS_TEXT.MAX_LENGTH_ERROR);
      } else {
        toast.error(DEFAULT_ERROR_MESSAGE);
      }
    }
  };

  return (
    <ModalScreen
      title={TEXTS.MODAL_AD_RENAME_TITLE}
      titlePlacement="left"
      onClose={close}
      actionButtons={[
        <Button
          key="button_rename_ad_campaign_modal"
          elementId="button_rename_ad_campaign_modal"
          type={ButtonType.PRIMARY}
          isDisabled={isRenameButtonDisabled}
          onClick={onRename}
          isLoading={loading}>
          {TEXTS.MODAL_AD_RENAME_BUTTON_CONFIRM}
        </Button>,
      ]}>
      <Input
        elementId="input_rename-campaign"
        label={TEXTS.MODAL_AD_RENAME_INPUT_LABEL}
        isDisabled={loading}
        labelClassName={styles.label}
        type={InputType.TEXT}
        value={name}
        onChange={setName}
      />
    </ModalScreen>
  );
};

export default AdRenameModal;
